import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const PercentageIcon = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_2334_1026)">
          <path
            d="M11.3332 12.0001C11.7014 12.0001 11.9998 11.7016 11.9998 11.3334C11.9998 10.9652 11.7014 10.6667 11.3332 10.6667C10.965 10.6667 10.6665 10.9652 10.6665 11.3334C10.6665 11.7016 10.965 12.0001 11.3332 12.0001Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.66667 5.33333C5.03486 5.33333 5.33333 5.03486 5.33333 4.66667C5.33333 4.29848 5.03486 4 4.66667 4C4.29848 4 4 4.29848 4 4.66667C4 5.03486 4.29848 5.33333 4.66667 5.33333Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4 12L12 4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2334_1026">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
